import { ACTIONS_PREFIX } from '../actions/archiveFilters';
import { createFiltersReducer } from '../utils';

const initialFiltersState = {
    pageNumber: 1,
    sortBy: 'deletionDate',
    sortOrder: 'desc',
};

const initialState = {
    currentFilters: {
        ...initialFiltersState
    },
    appliedFilters: {
        ...initialFiltersState
    }
};

const archiveFiltersReducer = createFiltersReducer(ACTIONS_PREFIX, initialState);
export default archiveFiltersReducer;
